import Image from "next/image";

export default function CoverImage({ title, coverImage, slug }) {
  if (coverImage?.sourceUrl == null) {
    return <></>;
  }
  return (
    <Image
      layout="fill"
      alt={`Cover Image for ${title}`}
      src={coverImage?.sourceUrl}
    />
  );
}
